import React from '../helpers/react';
import {toggleMobile} from '../actions/mobile.action.js';
import {connect} from '../helpers/composeReducer.js';
import classList from 'ereader-core/dist/classList';
import {getHookClass} from '../helpers/cssHooks.js';

import {trigger} from '../helpers/events.js';

export const MobileTab =  React.createClass({
  getInitialState: function(){
    return {};
  },

  toggleMobile : function(e) {
    this.props.toggleMobile({
      isActive: !this.props.mobile_tab.isActive
    });

    trigger('mobileClicked', {
      active: !this.props.mobile_tab.isActive
    });
    document.getElementById('notification').removeAttribute('aria-hidden');
    if(!this.props.mobile_tab.isActive) {
        document.getElementById('notification').innerHTML = this.props.getDef('mobile-tab.text-solution-popup-description');
    }
    else {
        document.getElementById('notification').innerHTML = "";
    }
  },

  keyDownMobileTab: function(e){
      e.preventDefault();
      // # Accessibility -- let element respond to Tab
      if (e.keyCode === 9) {
          if(this.props.show_bookmark) {
              document.getElementById('bookmark-tab').focus();
          }
          else {
              document.getElementById('show-all-steps').focus();
          }
      }
    // # Accessibility -- let element respond to ENTER and SPACE
    if(e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        e.currentTarget.click();
        return false;
    }

    // # Accessibility -- let element respond to Shift + Tab
    if(e.shiftKey && e.keyCode === 9) {
        if (!this.props.toc_visible) document.getElementById('toc-button').focus();
        else document.getElementsByClassName('chapter-current')[0].focus();
    }
  },

  render : function(){
    if (!this.props.show_mobile) {
      return null;
    }

    let mobileBtnClass = classList('button','button-icon','mobile-btn');
    mobileBtnClass.push(this.props.mobile_tab.isActive ? 'mobile-active' : 'mobile');

    let mainClass = classList('mobile-tab', getHookClass('MobileTab'));
    if(!this.props.show_fullscreen) {
      mainClass.push('no-fullscreen');
    }

    return (
      <button tabIndex="0" id="mobile-tab" onKeyDown={(e)=>this.keyDownMobileTab(e)} role="button" className={mobileBtnClass} onClick={this.toggleMobile} aria-label={this.props.getDef('mobile-tab.text-solution-aria-label')}></button>
    );
  }
});

export function mapStateToProps(state){
	return {
      problem : state.problem,
      chapter : state.chapter,
      isbn13 : state.model.isbn13,
      show_fullscreen: state.options.show_fullscreen,
      mobile_tab : state.mobile_tab,
      getDef : state.helpers.getDef,
      show_bookmark: state.options.show_bookmark,
      toc_visible : state.toc.visible,
      show_mobile: state.options.show_mobile
	};
}

export default connect(mapStateToProps,{
  toggleMobile
})(MobileTab);


// WEBPACK FOOTER //
// ./src/components/MobileTab.js